import React, { useState,useEffect,useParams } from "react";
import { Link } from "react-router-dom";
import GalleryFolderId from "../components/GalleryFolder";
import "./Gallery.css"
// commit
// import IconSocalFurs from './SocalDate.jpg'


export default function Gallery() {

  const [events, setEvents] = useState([]);
  const [data, setData] = useState([]);
  const [photos,setPhotos] = useState([]);


  useEffect(() => {
    fetch("https://socalfurs.com/socal_meetup_images.php")
      .then((response) => response.json()) 
      .then(data => {
        setData(data.photos); 
      })
      .catch((error) => console.error("Error fetching data:", error)); 
  }, []);

  

  // console.log(data)
//  const folders = data.map(item => ({
//   folderName: item.folder_name,
//   images: JSON.parse(item.folder_ids)  
  
// }));



const folders = data.map(item => {
  let images = [];

  try {
    // folder_ids may be a JSON string or an array
    if (typeof item.folder_ids === "string") 
    {
      images = JSON.parse(item.folder_ids);

    } else if (Array.isArray(item.folder_ids)) 
      
    {
      images = item.folder_ids;
    }
  } catch (e) {
    console.error("Bad JSON:", item.folder_ids);
  }

  return {
    folderName: item.folder_name,
    images,
    firstImage: images[0] || null   
  };
});


    // {folder.firstImage && (
    //   <img
    //     style={{ width: "400px", height: "400px" }}
    //     key={folder.firstImage}
    //     src={`https://socalfurs.com/socal_meetup_images/${folder.folderName}/${folder.firstImage}`}
    //     alt=""
    //   />
    // )}

// console.log("FOLDER DATA:  ",folders)
//   console.log(data)

// const foldersOne = data.map(item => ({
//   folderName: item.folder_name,
//   images: JSON.parse(item.folder_ids[0])  // convert string → array
// }));


const slugify = (str) =>
  str.toLowerCase()
     .replace(/[^a-z0-9]+/g, '-')   // replace spaces & special chars
     .replace(/(^-|-$)/g, '');      // trim dashes

// console.log("FOLDER",folders)

  return (
    <div className = "gallery-container">
      <div className = "padding-gallery"></div>
       <div className = "photo-welcome-container">

       
                  
                  <div className = "calendar-container-1">
                            <header className = "calendar-header">Welcome to Our Photo Page!</header>
                              {/* <img className="homepage-main-icon" src={IconSocalFursDate} alt="Socalfurs.com" /> */}
                            <p className = "calendar-p"> 
                    Before using or sending any photos for this page, please review
    SoCalFurs.com’s <strong>Photos On Site Forum Post</strong> and 
    <strong> Terms of Use</strong>. Please note that due to our submission
    policies, the gallery may appear mascot-suit heavy, even though suit
    owners are a minority of the community. If you have any questions or
    would like to have your photo included, please email it directly to us at
    <a href="mailto:Admin@SoCalFurs.com" className="photo-email">
      {" "}Admin@SoCalFurs.com
    </a>.
                              
                              </p>
                            
                    
                  </div>
      </div>
  {/* updaewwe */}

      <div className ="event-list-container">
            <div className = "photo-header-container">

             <h1 className = "photo-header">Socal Furs Photo Gallery</h1>
              <div class="my-line"></div>
        </div>
     
    
          <div className = "">
    
                 <ul className = "ul-event">
                  {folders.map(folder => (
                                <li className = "" key={folder.folderName}>
                                                    <div className = "space-gallery"></div>
                                                    <Link className = "link-header"
                                                              to={`/socal_meetup_images/${slugify(folder.folderName)}`}
                                                    >
                                                        <h2 className = "folder-header">{folder.folderName}</h2>
                                                    </Link>


                                              {folder.firstImage && (
                                                <div className = "outer-big">
                                                                     <div className = "outer-gallery">
                                                  <a href={`/socal_meetup_images/${slugify(folder.folderName)}`}>
                                                      <img
                                                        style={{ width: "200px", height: "200px" }}
                                                        src={`https://socalfurs.com/socal_meetup_images/${folder.folderName}/${folder.firstImage}`}
                                                        alt=""
                                                      />

                                                  </a>
                                          
                                                </div>
                                       
                                                </div>
                                               
                                                )}
                                          {/* <GalleryFolderId onFolder={folders}></GalleryFolderId> */}
                              
                                            {/* {folder.images.map(img => (
                                            <img style ={{width: "400px",height: "400px"}} key={img} src={"https://socalfurs.com/socal_meetup_images/" + folder.folderName + "/" + img } alt="" />
                                          ))} */}
                                          
                                        
                                        </li>
                                      ))}

                                  </ul>
          </div>
         

        </div>

      {/* hiiii */}
       {/* <div>{data ? data : 'No data yet...'}</div> */}
       {/* <ul> {data.map((eventItem, index) =>
       (

          <li key ={index}> {eventItem.eventname}</li>
       ))}
        </ul> */}
        {/* <div>{data.length > 0 ? data[0].id : "No data available"}</div> */}
      {/* <ul>

        {events.map(event => (
          <li key={event.id}>
            <h2>{event.eventname}</h2>
            <p>{event.date}</p>
            <img className = "picture-sizer" src={"https://drive.google.com/thumbnail?id=" + event.fileid} alt={event.eventname} />
            <p>{event.eventdescription}</p>
          </li>
        ))}
      </ul> */}
    </div>
  );
}
